
export interface Marker {
  lat: number;
  lon: number;
  label: string;
  colour?: string;
}

// eslint-disable-next-line max-len
export const accessToken = "pk.eyJ1IjoidHJhdmVsbG9jYWwiLCJhIjoiY2lsdWs0NHdnMDA1OHV4bTQzZnRoMmtiaCJ9.WaxX_cqhRxUPl-SxB9mNlA";

export const styleId = "ckgjgxc1c11ib19thuzmmescq";

const apiBase = "https://api.mapbox.com";

/**
 * Get the URL to use for the map in itinerary PDFs.
 * 
 * Docs: https://docs.mapbox.com/api/maps/#static-images
 */
export const getPdfMapUrl = (markers: Marker[] = []): string => {
  const width = 1280;
  const height = 800;

  const markerString = markers
    .map(m => `pin-l-${m.label}+${m.colour ?? "3a9e5d"}(${m.lon},${m.lat})`)
    .join(",");

  const overlayString = [markerString].join(",");

  return `${apiBase}/styles/v1/travellocal/${styleId}/static/${overlayString}`
    + `/auto/${width}x${height}@2x`
    + `?access_token=${accessToken}`;
}
